import {Component, EventEmitter, Input, Output} from "@angular/core";
import {localizationKey} from "../../../../i18n/i18n-model";
import {EcgWorkflow} from "../hospital.details";


@Component({
    selector: "app-technicians-section",
    templateUrl: "./technicians-section.component.html",
    standalone: false
})
export class TechniciansSectionComponent {

  @Input() assignSleepTechniciansEnabled!: boolean;
  @Input() hospitalId!: number;
  @Input() ecgWorkflow!: EcgWorkflow;

  @Output() settingsChanged = new EventEmitter<{assignSleepTechniciansEnabled: boolean, ecgWorkflow: EcgWorkflow}>();

  constructor() {
  }

  protected readonly localizationKey = localizationKey;

  onAssignSleepTechniciansChange(value: boolean) {
    this.assignSleepTechniciansEnabled = value;
    this.emitSettings();
  }

  onEcgWorkflowChange(value: EcgWorkflow) {
    this.ecgWorkflow = value;
    this.emitSettings();
  }

  private emitSettings() {
    this.settingsChanged.emit({
      assignSleepTechniciansEnabled: this.assignSleepTechniciansEnabled,
      ecgWorkflow: this.ecgWorkflow
    });
  }
}
